import React from "react";

export const ORDER_STATUS_STYLES = {
  pending: "bg-amber-50 text-amber-600",
  paid: "bg-palm-light text-palm-500",
  processing: "bg-gold/10 text-gold-600",
  shipped: "bg-ocean/10 text-ocean",
  delivered: "bg-palm-light text-palm-500",
  cancelled: "bg-red-50 text-red-500",
  refunded: "bg-red-50 text-red-500",
};

export const PAYMENT_STATUS_STYLES = {
  paid: "bg-palm-light text-palm-500",
  pending: "bg-amber-50 text-amber-600",
  payment_pending: "bg-amber-50 text-amber-600",
  payment_failed: "bg-red-50 text-red-500",
  failed: "bg-red-50 text-red-500",
};

export function StatusBadge({ status, styles = ORDER_STATUS_STYLES, className = "" }) {
  const cls = styles[status] || "bg-muted text-muted-foreground";
  return (
    <span className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-semibold capitalize ${cls} ${className}`}>
      {status || "—"}
    </span>
  );
}

export function ActiveBadge({ active }) {
  return active ? (
    <span className="inline-flex items-center gap-1 rounded-full bg-palm-light px-2.5 py-0.5 text-xs font-semibold text-palm-500">
      <span className="h-1.5 w-1.5 rounded-full bg-palm-500" /> Active
    </span>
  ) : (
    <span className="inline-flex items-center gap-1 rounded-full bg-muted px-2.5 py-0.5 text-xs font-semibold text-muted-foreground">
      <span className="h-1.5 w-1.5 rounded-full bg-muted-foreground" /> Inactive
    </span>
  );
}

export function StockBadge({ stock }) {
  if (stock <= 0) return <span className="font-semibold text-red-500">Out of stock</span>;
  if (stock < 10) return <span className="font-semibold text-amber-600">{stock} left</span>;
  return <span className="text-navy">{stock} in stock</span>;
}
